import cn from 'classnames';
import React from 'react';

import style from './BaseIcon.module.scss';

export const IconColor = {
  Main: 'main',
  Brand: 'brand',
  Primary: 'primary',
  Secondary: 'secondary',
  Bg: 'bg',
  Gray: 'gray',
  Inherit: 'inherit',
  Error: 'error',
  White: 'white',
  Black: 'black'
} as const;

export type IconColorKeys = (typeof IconColor)[keyof typeof IconColor];

export const IconSize = {
  XXS: 12,
  XS: 16,
  SM: 18,
  M: 20,
  L: 24,
  XL: 32,
  XXL: 40
};

export type BaseIconProps = React.SVGAttributes<SVGElement> & {
  className?: string;
  color?: IconColorKeys;
  size?: number;
};

const BaseIcon: React.FC<React.PropsWithChildren<BaseIconProps>> = ({
  color = IconColor.Inherit,
  size = IconSize.M,
  height,
  width,
  className,
  children,
  ...rest
}) => {
  const finalHeight = height ?? size;
  const finalWidth = width ?? size;

  return (
    <svg
      {...rest}
      height={finalHeight}
      width={finalWidth}
      xmlns="http://www.w3.org/2000/svg"
      className={cn(style[`base-icon_${color}`], className)}
    >
      {children}
    </svg>
  );
};

export default BaseIcon;
